import { createSlice } from '@reduxjs/toolkit';
import { IMeter } from '../../models/IMeter';

interface metersStateI {
	isLoading: boolean;
	loadingProgress: number;
	meters: IMeter[];
	sort: { sortOrder: string; sortField: string };
	page: number;
	start: number;
	search: {};
	totalSize: number;
	filter: {};
	sizePerPage: number;
	counterName: string;
	serviceName: string;
	lsNumber: string;
}

const initialState: metersStateI = {
	isLoading: false,
	loadingProgress: 0,
	meters: [],
	sort: {
		sortOrder: '',
		sortField: '',
	},
	page: 1,
	start: 0,
	search: {},
	totalSize: 0,
	filter: {},
	sizePerPage: 10,
	counterName: '',
	serviceName: '',
	lsNumber: '',
};

export const metersSlice = createSlice({
	name: 'meters',
	initialState,
	reducers: {
		setCounterName: (state, data) => {
			state.counterName = data.payload;
		},
		setServiceName: (state, data) => {
			state.serviceName = data.payload;
		},
		setLsNumber: (state, data) => {
			state.lsNumber = data.payload;
		},
		setLoading: (state, data) => {
			state.isLoading = data.payload;
		},
		setLoadingProgress: (state, data) => {
			state.loadingProgress = data.payload;
		},
		setMeters: (state, data) => {
			state.meters = data.payload;
		},
		setTotalSizeMeters: (state, data) => {
			state.totalSize = data.payload;
		},
		setPageMeters: (state, data) => {
			state.page = data.payload;
		},
		setStart: (state, data) => {
			state.start = data.payload;
		},
		setSort: (state, sort) => {
			state.sort = sort.payload;
		},
		setFilter: (state, data) => {
			state.filter = data.payload;
		},
		setSearch: (state, data) => {
			// state.search.push({data.payload.type:data.payload.value});
			Object.assign(state.search, data.payload);
		},
		/*setSearchOption: (state, data) => {
            state.searchOption = data.payload;
        },*/
		setSizePerPageCalls: (state, sizePerPage) => {
			state.sizePerPage = sizePerPage.payload;
		},
		/*setSearchStartCalls: (state, searchStart) => {
            state.searchStart = searchStart.payload;
        },*/
		/*setSearchEndCalls: (state, searchEnd) => {
            state.searchEnd = searchEnd.payload;
        },*/
	},
});

export default metersSlice.reducer;
export const {
	setLoading,
	setLoadingProgress,
	setMeters,
	setTotalSizeMeters,
	setPageMeters,
	setSizePerPageCalls,
	setSort,
	setSearch,
	setStart,
	setCounterName,
	setServiceName,
	setLsNumber
} = metersSlice.actions;
